import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { HiOutlineBars3, HiOutlineXMark, HiChevronDown } from "../components/common/LightIcons";
import { services } from "../data/siteData";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setScrolled(window.scrollY > 18);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setServicesOpen(false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="shell nav-shell">
        <Link to="/" className="brand" aria-label="Navastha Infotech home">
          <span className="brand-mark"><img src={require("../assets/HomePage/images/Navastha.jpg")} alt="Navastha Infotech" /></span>
          <span className="brand-copy"><strong>Navastha</strong><small>INFOTECH</small></span>
        </Link>

        <nav className="desktop-nav" aria-label="Primary navigation">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <div className="nav-drop" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)}>
            <NavLink to="/services" className={({ isActive }) => isActive || location.pathname.startsWith("/services/") ? "active" : ""}>Services <HiChevronDown /></NavLink>
            {servicesOpen && (
              <div className="mega-menu">
                <div className="mega-intro"><span>What we do</span><strong>Technology that moves business forward.</strong><Link to="/services">Explore all services →</Link></div>
                <div className="mega-links">
                  {services.map((service) => {
                    const Icon = service.icon;
                    return <Link key={service.slug} to={`/services/${service.slug}`}><Icon/><span><b>{service.title}</b><small>{service.short}</small></span></Link>;
                  })}
                </div>
              </div>
            )}
          </div>
          <NavLink to="/portfolio">Work</NavLink>
          <NavLink to="/blogs">Insights</NavLink>
        </nav>

        <div className="nav-actions">
          <Link to="/contact" className="btn btn-primary nav-cta">Let's talk <span>↗</span></Link>
          <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Toggle menu" aria-expanded={open}>{open ? <HiOutlineXMark /> : <HiOutlineBars3 />}</button>
        </div>
      </div>

      {open && (
        <div className="mobile-menu">
          <div className="shell mobile-menu-inner">
            <NavLink to="/">Home</NavLink><NavLink to="/about">About</NavLink><NavLink to="/services">Services</NavLink>
            <div className="mobile-service-list">{services.map(s => <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>)}</div>
            <NavLink to="/portfolio">Work</NavLink><NavLink to="/blogs">Insights</NavLink><NavLink to="/contact">Contact</NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
